import React from 'react';
import { Navigate } from 'react-router-dom';
import { ShieldOff } from 'lucide-react';
import { usePageAccess } from '../../hooks/usePageAccess';
import { getPageConfig } from '../../config/pagePermissions';

interface PageGuardProps {
  pageKey: string;
  children: React.ReactNode;
}

export const PageGuard: React.FC<PageGuardProps> = ({ pageKey, children }) => {
  const { hasAccess } = usePageAccess();

  if (hasAccess(pageKey)) {
    return <>{children}</>;
  }

  const page = getPageConfig(pageKey);

  return (
    <div className="flex items-center justify-center min-h-[60vh] p-6">
      <div className="max-w-md w-full text-center space-y-6">
        <div className="mx-auto w-16 h-16 rounded-full bg-red-100 dark:bg-red-900/30 flex items-center justify-center">
          <ShieldOff className="h-8 w-8 text-red-600 dark:text-red-400" />
        </div>
        <div>
          <h2 className="text-xl font-bold text-gray-900 dark:text-gray-100">
            Access Restricted
          </h2>
          <p className="mt-2 text-gray-600 dark:text-gray-400">
            You do not have permission to access{' '}
            <span className="font-medium text-gray-900 dark:text-gray-200">
              {page?.label ?? 'this page'}
            </span>
            . Contact your administrator to request access.
          </p>
        </div>
        <a
          href="/dashboard"
          className="inline-flex items-center px-4 py-2 rounded-lg bg-primary-600 text-white hover:bg-primary-700 transition-colors text-sm font-medium"
        >
          Back to Dashboard
        </a>
      </div>
    </div>
  );
};
